const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlFollowUpInspection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38619 12.9124C4.9875 13.6428 5.99585 14.6356 7.2662 15.4714C8.65952 16.3881 10.3341 17.0939 12.1099 17.0939C13.8851 17.0939 15.5232 16.3883 16.8692 15.4736C18.1017 14.6361 19.0628 13.6408 19.626 12.9123C19.1112 12.1573 18.2041 11.1242 16.9911 10.2543C15.668 9.30554 14.0062 8.56829 12.1099 8.56829C10.2134 8.56829 8.51472 9.30566 7.14429 10.2567C5.89351 11.1247 4.93902 12.1553 4.38619 12.9124ZM6.63117 9.5173C8.1015 8.49694 9.97657 7.66829 12.1099 7.66829C14.2456 7.66829 16.0874 8.49878 17.5156 9.52294C18.9414 10.5454 19.98 11.7782 20.52 12.6345C20.6396 12.824 20.6317 13.0643 20.5006 13.2456C19.91 14.0621 18.8137 15.2404 17.375 16.218C15.9363 17.1957 14.1235 17.9939 12.1099 17.9939C10.0987 17.9939 8.25243 17.1976 6.77153 16.2233C5.28977 15.2484 4.13992 14.0734 3.51167 13.2592C3.36719 13.072 3.35896 12.8157 3.49182 12.6195C4.0699 11.7659 5.16228 10.5367 6.63117 9.5173Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 16.2416C13.883 16.2416 15.4099 14.7147 15.4099 12.8312C15.4099 10.9477 13.883 9.42077 11.9995 9.42077C10.116 9.42077 8.58909 10.9477 8.58909 12.8312C8.58909 14.7147 10.116 16.2416 11.9995 16.2416ZM11.9995 17.1416C14.3801 17.1416 16.3099 15.2118 16.3099 12.8312C16.3099 10.4506 14.3801 8.52077 11.9995 8.52077C9.61893 8.52077 7.68909 10.4506 7.68909 12.8312C7.68909 15.2118 9.61893 17.1416 11.9995 17.1416Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0618 13.5256C12.4539 13.5256 12.7717 13.2078 12.7717 12.8158C12.7717 12.4237 12.4539 12.1059 12.0618 12.1059C11.6698 12.1059 11.352 12.4237 11.352 12.8158C11.352 13.2078 11.6698 13.5256 12.0618 13.5256ZM12.0618 14.4256C12.951 14.4256 13.6717 13.7049 13.6717 12.8158C13.6717 11.9266 12.951 11.2059 12.0618 11.2059C11.1727 11.2059 10.452 11.9266 10.452 12.8158C10.452 13.7049 11.1727 14.4256 12.0618 14.4256Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92188 3.9043H5.79695C6.04548 3.9043 6.24695 4.10577 6.24695 4.3543C6.24695 4.60283 6.04548 4.8043 5.79695 4.8043H3.82187V6.77223C3.82187 7.02075 3.6204 7.22223 3.37187 7.22223C3.12335 7.22223 2.92188 7.02075 2.92188 6.77223V3.9043Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0777 3.9043H18.2027C17.9541 3.9043 17.7527 4.10577 17.7527 4.3543C17.7527 4.60283 17.9541 4.8043 18.2027 4.8043H20.1777V6.77223C20.1777 7.02075 20.3792 7.22223 20.6277 7.22223C20.8763 7.22223 21.0777 7.02075 21.0777 6.77223V3.9043Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0777 21.7584H18.2027C17.9541 21.7584 17.7527 21.5569 17.7527 21.3084C17.7527 21.0599 17.9541 20.8584 18.2027 20.8584H20.1777V18.8905C20.1777 18.6419 20.3792 18.4405 20.6277 18.4405C20.8763 18.4405 21.0777 18.6419 21.0777 18.8905V21.7584Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.92188 21.7584H5.79695C6.04548 21.7584 6.24695 21.5569 6.24695 21.3084C6.24695 21.0599 6.04548 20.8584 5.79695 20.8584H3.82187V18.8905C3.82187 18.6419 3.6204 18.4405 3.37187 18.4405C3.12335 18.4405 2.92188 18.6419 2.92188 18.8905V21.7584Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlFollowUpInspection);
export default __webpack_public_path__ + "static/media/kl-follow-up-inspection.4d5e7163049147141645b5b6855ed1dd.svg";
export { ForwardRef as ReactComponent };